import React from "react";
const PrintIcon = () => {
  return (
    <svg
      className="print-icon"
      width="40"
      height="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="none"
        id="canvas_background"
        height="42"
        width="42"
        y="-1"
        x="-1"
      />
      <g>
        <path
          fill="#fff"
          stroke="null"
          id="svg_1"
          d="m34.740212,14.677144l-3.275603,0l0,-10.236258a2.049708,2.049708 0 0 0 -2.047252,-2.047252l-18.834715,0a2.049708,2.049708 0 0 0 -2.047252,2.047252l0,10.236258l-3.275603,0a3.689147,3.689147 0 0 0 -3.685053,3.685053l0,10.236258a3.689147,3.689147 0 0 0 3.685053,3.685053l3.275603,0l0,3.275603a2.049708,2.049708 0 0 0 2.047252,2.047252l18.834715,0a2.049708,2.049708 0 0 0 2.047252,-2.047252l0,-3.275603l3.275603,0a3.689147,3.689147 0 0 0 3.685053,-3.685053l0,-10.236258a3.689147,3.689147 0 0 0 -3.685053,-3.685053zm-24.567019,-10.236258a0.414773,0.414773 0 0 1 0.40945,-0.40945l18.834715,0a0.414773,0.414773 0 0 1 0.40945,0.40945l0,10.236258l-19.653615,0l0,-10.236258zm19.653615,31.118224a0.414773,0.414773 0 0 1 -0.40945,0.40945l-18.834715,0a0.414773,0.414773 0 0 1 -0.40945,-0.40945l0,-7.779556l19.653615,0l0,7.779556zm6.960655,-6.960655a2.049708,2.049708 0 0 1 -2.047252,2.047252l-3.275603,0l0,-4.503954l-22.929218,0l0,4.503954l-3.275603,0a2.049708,2.049708 0 0 1 -2.047252,-2.047252l0,-10.236258a2.049708,2.049708 0 0 1 2.047252,-2.047252l29.480423,0a2.049708,2.049708 0 0 1 2.047252,2.047252l0,10.236258zm-9.417357,-5.732304l3.275603,0l0,1.637801l-3.275603,0l0,-1.637801zm-15.559112,6.141755l16.378013,0l0,1.637801l-16.378013,0l0,-1.637801zm0,3.275603l16.378013,0l0,1.637801l-16.378013,0l0,-1.637801z"
        />
      </g>
    </svg>
  );
};

export default PrintIcon;



// WEBPACK FOOTER //
// ./src/components/PrintIcon.js